<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
      aria-label="Measuring storage"
    ></v-progress-linear>
    <template v-if="usage">
      <p class="mb-2">
        <strong>{{ size(usage.usedBytes) }}</strong> of {{ size(usage.limitBytes) }} used
      </p>
      <v-progress-linear
        :value="usage.percentUsed"
        :color="usage.percentUsed >= 90 ? 'warning' : 'primary'"
        height="10"
        rounded
        :aria-label="`${usage.percentUsed}% of storage used`"
      ></v-progress-linear>
      <p class="mt-3">
        {{ size(usage.remainingBytes) }} available<span v-if="usage.reservedBytes"> · {{ size(usage.reservedBytes) }} reserved for uploads or AI images</span>
      </p>
      <v-alert
        v-if="usage.full"
        type="warning"
        outlined
      >
        Storage is full. {{ usage.upgradePlans.length ? 'Upgrade below or delete media to free space.' : 'You have the largest plan. Delete media to free space.' }}
      </v-alert>
    </template>
    <p
      v-if="error"
      role="alert"
    >
      {{ error }}
    </p>
    <p class="text-body-2">
      Counts photos, videos, restored images and previews after processing. Deleting a story keeps its media; permanently delete media from the gallery to free space.
    </p>
    <v-btn
      text
      color="primary"
      @click="$store.commit('showGallery', { open: true, list: true })"
    >
      Manage media
    </v-btn>
    <v-btn
      text
      :loading="loading"
      @click="refresh"
    >
      Refresh storage
    </v-btn>
  </div>
</template>
<script>
import billing from '@/services/billing'

export default {
  data: () => ({ usage: null, loading: false, error: '' }),
  mounted() {
    this.refresh()
    window.addEventListener('billing:changed', this.refresh)
    window.addEventListener('focus', this.refresh)
  },
  beforeDestroy() {
    window.removeEventListener('billing:changed', this.refresh)
    window.removeEventListener('focus', this.refresh)
  },
  methods: {
    size(bytes) {
      const divisor = [1e9, 1e6, 1e3, 1].find(value => bytes >= value) || 1

      return `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(bytes / divisor)} ${{
        1: 'B', 1000: 'KB', 1000000: 'MB', 1000000000: 'GB',
      }[divisor]}`
    },
    async refresh() {
      if (this.loading) return
      this.loading = true; this.error = ''
      try { this.usage = await billing.storage() } catch (_) { this.usage = null; this.error = 'Storage could not be measured. Please try again.' } finally { this.loading = false }
    },
  },
}
</script>
